import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Box, Divider, List, ListItem } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab";
import styles from './styles'

const numberOfSkeletons = 6

const SkeletonTab = props => {
  const { classes } = props

  const renderSkeleton = () => (
    Array(numberOfSkeletons).fill().map((_, i) => (
      <Fragment key={i}>
        <ListItem className={classes.listItem}>
          <Skeleton className={classes.skeletonAvatar} variant='circle'/>
          <Box>
            <Skeleton height={20} width={300}  variant='text'/>
            <Skeleton height={20} width={100}  variant='text'/>
            <Skeleton height={20} width={200}  variant='text'/>
          </Box>
        </ListItem>
        <Divider variant="inset"/>
      </Fragment>
    ))
  )

  return (
    <List>
      {renderSkeleton()}
    </List>
  )
}

export default withStyles(styles)(SkeletonTab)
